import { compose, withHandlers, setPropTypes, setDisplayName } from 'recompose';
import PropTypes from 'prop-types';
import detectVariants from '@dc/fo-experiment/lib/detectVariants.js';

import {
  addProductToBasket,
  PRODUCT_ADDED_TO_BASKET,
  changeCartItemsCount
} from '../../../../appState/ducks/general';
import { PSA_SWITCHED_OFF }
  from '../../PopupStyleAttach/components/PSAPopup/PSAPopup';
import { triggerMainProductAddedEvent }
  from '../../PopupStyleAttach/helpers/triggerMainProductAddedEvent';

const withAddToBasketAjaxCallHandler = () => compose(
  setDisplayName('withAddToBasketHandler'),
  setPropTypes(
    {
      dispatch: PropTypes.func.isRequired, // requires dispatch from Redux
      thisButtonId: PropTypes.string.isRequired, // ID of button which runs this handler
      fupid: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
      deliverySlotLabel: PropTypes.string, // For MCD Delivery Slot
      deliverySlotPrice: PropTypes.string, // For MCD Delivery Slot
      deliverySlotId: PropTypes.string, // For MCD Delivery Slot
      deliverySlotPostCode: PropTypes.string, // For MCD Delivery Slot
      deliverySlotDate: PropTypes.string, // For REGULAR MCD Delivery Slot
      sameDayDelivery: PropTypes.string, // For Same Day Delivery MCD Delivery Slot
      storeId: PropTypes.number, // For RnC and PnC collections
      deliveryType: PropTypes.oneOf(['RESERVE_AND_COLLECT', 'PAY_AND_COLLECT', 'PAY_AND_COLLECT_FROM_STORE_STOCK']), // For RnC, PnCSS and PnC collections
      visitorId: PropTypes.string, // For Syntasa bundles
      mainProductId: PropTypes.string, // For PSA - attachments to be loaded for main product
      mainProductSegmentId: PropTypes.number, // For attachments filter - same product category to be filtered from attachments
      addonProductsIds: PropTypes.arrayOf(PropTypes.string), // accessory products for dynamic bundle
      addonProductsNames: PropTypes.arrayOf(PropTypes.string), // accessory products names dynamic bundle,
      addonProductsSegmentIds: PropTypes.arrayOf(PropTypes.number), // accessory products categories for dynamic bundle,
      wasAddedFromWishlist: PropTypes.bool, // flag it it was added from wishlist
      psaVariant: PropTypes.string,
      buttonPlacementID: PropTypes.string
    }
  ),
  withHandlers({
    addToBasket: (props) => async () => {
      const resultOfAddingToBasket =
        await props.dispatch(addProductToBasket(
          {
            ...props
          }
        ));

      if (resultOfAddingToBasket.status === PRODUCT_ADDED_TO_BASKET) {
        props.dispatch(changeCartItemsCount(1));

        // read configuration from AB tests
        const experimentsConfiguration = typeof window !== 'undefined' ? {
          ...window.EXPT_CONFIG,
          QUERY: window.location.search
        } : {};

        const psaVariantFromExptConfig = detectVariants(
          `psa-${props.buttonPlacementID}`,
          experimentsConfiguration
        );
        const psaVariant = psaVariantFromExptConfig || props.psaVariant;

        // PSA is switched ON - dispatch event
        if (psaVariant !== PSA_SWITCHED_OFF) {
          triggerMainProductAddedEvent(
            props.fupid,
            resultOfAddingToBasket.response.basketConfirmationUrl,
            props.storeId,
            props.deliveryType,
            props.mainProductId,
            props.mainProductSegmentId,
            props.addonProductsIds,
            props.addonProductsNames,
            props.addonProductsSegmentIds,
            props.bundlePrice
          );
          // PSA is switched OFF - redirect to step page
        } else {
          window.location.href = resultOfAddingToBasket.response.redirectUrl;
        }
      }
    }
  })
);

export default withAddToBasketAjaxCallHandler;
